module.exports = __webpack_public_path__ + "img/category_example.91c4063e.png";